import { useForm } from 'react-hook-form';

export const useGenericTable = () => {
  const genericTableForm = useForm();

  return {
    genericTableForm,
  };
};
